import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { ImagePlacementVariants } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostListing(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostListingInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostListing,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.BlogPostListing,
    maxPosts: 6,
    maxPostsPerRow: 3,
    rowsGap: 30,
    columnsGap: 30,
    showDate: false,
    displayHorizontally: false,
    titleFontSize: 26,
    mobileTitleFontSize: 22,
    titleColor: 'rgba(20, 45, 99, 1)',
    titleAlign: 'left',
    categoriesFontSize: 18,
    categoriesColor: 'rgba(27, 160, 255, 1)',
    categoriesAlign: 'left',
    descriptionFontSize: 22,
    mobileDescriptionFontSize: 18,
    descriptionColor: 'rgba(100, 101, 126, 1)',
    descriptionAlign: 'left',
    dateFontSize: 18,
    dateColor: 'rgba(20, 45, 99, 1)',
    dateAlign: 'left',
    paginationActiveColor: 'rgba(0, 165, 255, 1)',
    paginationActiveBackgroundColor: 'rgba(255, 255, 255, 1)',
    paginationInactiveColor: 'rgba(85, 95, 110, 1)',
    paginationInactiveBackgroundColor: 'rgba(228, 232, 238, 1)',
    mobileImagePlacement: ImagePlacementVariants.Up,
    imagePlacement: ImagePlacementVariants.Up,
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    imageMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    titleMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    categoriesMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    descriptionMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    dateMargin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
  } as BlogPostListingInterface
}
